<script lang="ts">
    import Vue from "vue";
    import { Component } from 'vue-facing-decorator';
    import { tchMarked } from "@common/Common";
    import { AlternativesComparisonDialogViewModel } from '@Alternatives/AlternativesLists/Components/AlternativesComparisonDialog';
    import { AlternativesComparisonAlternativeReadModel, AlternativesComparisonAttributeReadModel, AlternativesComparisonReadModel } from '@Alternatives/AlternativesLists/Domain/readmodels';

    @Component({
        props: {
            viewModel: {
                type: Object,
                required: true
            }
        }
    })
    export default class AlternativesComparisonDialog extends Vue
    {
        get vm(): AlternativesComparisonDialogViewModel { return this.$props.viewModel as AlternativesComparisonDialogViewModel; }
        get opened(): boolean { return this.vm?.opened ?? false; }

        get initialized(): boolean { return this.vm.initialized; }
        
        get includeDescription(): boolean { return this.vm.data.IncludeDescription; }
        get includeStatus(): boolean { return this.vm.data.IncludeStatus; }
        get attributes(): AlternativesComparisonAttributeReadModel[] { return this.vm.data.Attributes; }
        get alternatives(): AlternativesComparisonAlternativeReadModel[] { return this.vm.data.Alternatives; }


        getHtmlDescription(a: AlternativesComparisonAlternativeReadModel): string { return tchMarked(a.Description); }

        getAttributeValue(a: AlternativesComparisonAlternativeReadModel, attrId: number): string
        {
            return a.Values.find(v => v.AttributeId === attrId).Value;
        }

        close()
        {
            this.vm.close();
        }
    }

</script>

<template>
    <div class="modal-mask" v-if="opened">
        <div class="modal-wrapper">
            <div class="modal-dialog modal-xl modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Comparison</h5>
                        <button type="button" class="close" @click="close">&times;</button>
                    </div>

                    <div class="modal-body">
                        <h2 v-if="!initialized"><i class="fa fa-spinner fa-spin"></i> Loading...</h2>

                        <div v-if="initialized">
                            <table class="table table-hover">
                                <thead>
                                    <tr>
                                        <th></th>
                                        <th v-for="a in alternatives" :key="a.Id">{{a.Name}}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-if="includeDescription === true">
                                        <th>Description</th>
                                        <td v-for="a in alternatives" :key="a.Id">
                                            <span v-html="getHtmlDescription(a)"></span>
                                        </td>
                                    </tr>
                                    <tr v-if="includeStatus === true">
                                        <th>Status</th>
                                        <td v-for="a in alternatives" :key="a.Id">
                                            {{a.StatusName}}
                                        </td>
                                    </tr>
                                    <tr v-for="attr in attributes" :key="attr.Id">
                                        <th>{{attr.Name}}</th>
                                        <td v-for="a in alternatives" :key="a.Id">
                                            {{getAttributeValue(a, attr.Id)}}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>

                        </div>
                    </div>

                    <div class="modal-footer">
                        <button @click="close" type="button" class="btn btn-outline-secondary">Close</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>